import { Layout } from "antd"
import { memo } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { Outlet } from "react-router"
import { ErrorFallback } from "./ErrorBoundary"

const Content = memo(() => {
  return (
    <Layout.Content
      className="relative flex h-full flex-col overflow-y-auto overflow-x-hidden p-2"
      style={{ overscrollBehavior: "contain" }}
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>{<Outlet />}</ErrorBoundary>
    </Layout.Content>
  )
})

Content.displayName = "Content"

export default Content
